import type { Booking } from "@common/types";
import type { User } from "../stores/auth-store";

/** Mirrors the server's creator-only cancellation rule for partner users. */
export function canCancelBooking(booking: Booking, user: Pick<User, "id" | "role" | "partnerId"> | null | undefined): boolean {
  return user?.role === "admin" || !!(user?.partnerId && booking.partnerId === user.partnerId && booking.userId === user.id);
}
